import React from 'react';
import { BaasicInput, BaasicSelect, Loader, BaasicHeader, BaasicButton, BaasicModal } from 'core/components';
import { translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import { SellerEdit3PLCredentials, SellerWarehouse } from 'modules/seller/pages';
import _ from 'lodash';

const SellerEditTemplate = ({ sellerEditViewStore, t }) => {
	const {
		form,
		loading,
		rootStore,
		isUpdateAction,
		handleOnTimezoneMenuScroll,
		timezoneOptions,
		onSelectChange,
		stateOptions,
		countryOptions,
		handleOnStateMenuScroll,
		handleOnCountryMenuScroll,
		isTimezoneLoading,
		isStateLoading,
		isCountryLoading,
		debouncedTimezoneSearch,
		debouncedStateSearch,
		debouncedCountrySearch,
		onMenuClose,
		isHavingAPIKey,
		generateApiKey,
		openEditSeller3PLCredentialsModal,
		openEditSellerWarehousesModal,
	} = sellerEditViewStore;
	if (loading) return <Loader />;
	return (
		<section>
			<BaasicHeader title="SELLERVIEW.TITLE" rootStore={rootStore}>
				{isUpdateAction && (
					<BaasicButton
						className="btn btn--med btn--primary btn--primary--negative spc--right--tny"
						icon="icon icon--xmed icon--warehouse-change--white spc--right--sml" 
						onClick={() => {
							openEditSellerWarehousesModal();
						}}
						label="SELLERWAREHOUSE.TITLE"
					/>
				)}
				<BaasicButton
					className="btn btn--med btn--primary btn--primary--negative"
					icon="icon icon--xmed icon--list-edit--white spc--right--sml"
					onClick={() => {
						openEditSeller3PLCredentialsModal();
					}}
					label="SELLER3PLCREDENTIALS.EDIT"
				/>
			</BaasicHeader>
			<form className="container container--med container--footer" onSubmit={form.onSubmit}>
				<div className="container__group__wrapper">
					<div className="spc--bottom--sml">
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('applicationTitle')} />
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('identifier')} />
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('minimumInventory')} />
							</div>
						</div>
					</div>

					<h2 className="spc--bottom--sml">{t('WAREHOUSEVIEW.ADDRESS')}</h2>
					<div className="row spc--bottom--med">
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.address1')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.address2')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.address3')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.city')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.zipCode')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicSelect
								field={form.$('country.id')}
								isClearable={true}
								options={countryOptions.slice()}
								value={form.$('country.id').value}
								onChange={value => onSelectChange(value, form.$('country.id'), false)}
								onMenuScrollToBottom={handleOnCountryMenuScroll}
								onInputChange={debouncedCountrySearch}
								onMenuClose={() => onMenuClose(['country'])}
								isLoading={isCountryLoading}
							/>
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicSelect
								field={form.$('state.id')}
								isClearable={true}
								options={stateOptions.slice()}
								value={form.$('state.id').value}
								onChange={value => onSelectChange(value, form.$('state.id'), false)}
								onMenuScrollToBottom={handleOnStateMenuScroll}
								onInputChange={debouncedStateSearch}
								onMenuClose={() => onMenuClose(['state'])}
								isLoading={isStateLoading}
							/>
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicSelect
								field={form.$('timezone.id')}
								isClearable={true}
								options={timezoneOptions.slice()}
								value={form.$('timezone.id').value}
								onChange={value => onSelectChange(value, form.$('timezone.id'), false)}
								onMenuScrollToBottom={handleOnTimezoneMenuScroll}
								onInputChange={debouncedTimezoneSearch}
								onMenuClose={() => onMenuClose(['timezone'])}
								isLoading={isTimezoneLoading}
							/>
						</div>
					</div>

					<div className="spc--bottom--sml">
						<h2 className="spc--bottom--sml">{t('WAREHOUSEVIEW.CONTACT')}</h2>
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.email1')} />
							</div>
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.phone1')} />
							</div>
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.email2')} />
							</div>
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.phone2')} />
							</div>
							{!isUpdateAction && (
								<React.Fragment>
									<div className="col col-sml-12">
										<div className="separator--primary spc--top--sml spc--bottom--sml"></div>
									</div>
									<div className="col col-sml-12">
										<BaasicInput field={form.$('email')} />
									</div>
									<div className="col col-sml-6">
										<BaasicInput field={form.$('password')} />
									</div>
									<div className="col col-sml-6">
										<BaasicInput field={form.$('confirmPassword')} />
									</div>
								</React.Fragment>
							)}
						</div>
					</div>
					<div className="spc--bottom--med">
						<h2 className="spc--bottom--sml">{t('WAREHOUSEVIEW.APISECTION')}</h2>

						<div className="inputgroup">
							<div className="inputgroup--main">
								<BaasicInput field={form.$('apiKey')} disabled />
							</div>
							{!isHavingAPIKey ? (
								<div className="inputgroup--aside align--v--bottom">
									<button
										className="btn btn--med btn--secondary spc--bottom--sml spc--left--xsml"
										type="button"
										onClick={generateApiKey}
									>
										{t('GENERATEAPIKEY')}
									</button>
								</div>
							) : null}
						</div>
					</div>
				</div>
				{form.error && (
					<div>
						<p className="type--color--warning">{translate(form.error)}</p>
					</div>
				)}
				<button className="btn btn--med btn--primary" type="submit" disabled={loading}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{t('SAVE')}
				</button>
			</form>
			<BaasicModal className="ReactModal--lrg" modalParams={sellerEditViewStore.editSeller3PLCredentialsModal}>
				<SellerEdit3PLCredentials parentViewStore={sellerEditViewStore} />
			</BaasicModal>
			<BaasicModal className="ReactModal--sml-med" modalParams={sellerEditViewStore.editSellerWarehousesModal}>
				<SellerWarehouse parentViewStore={sellerEditViewStore} />
			</BaasicModal>
		</section>
	);
};

export default defaultTemplate(SellerEditTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/seller/pages/SellerEditTemplate.jsx